'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

function getActiveElement(el) {
  let activeElement = el.ownerDocument.activeElement;
  while (activeElement?.shadowRoot) {
    const el2 = activeElement.shadowRoot.activeElement;
    if (el2 === activeElement)
      break;
    else
      activeElement = el2;
  }
  return activeElement;
}

exports.getActiveElement = getActiveElement;
